import {
	endpointsMap,
	IGetOrderByEmailOptions,
	IGetOrderByZipCodeOptions,
	IGetOrderResponse
} from './ICustomShopperOrders';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperOrders
 */
class CustomShopperOrders extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Gets an order based on the orderNo and email passed
	 * @param {IGetOrderByEmailOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetOrderResponse} - Order
	 */
	public async getOrderByEmail(fetchOptions: IGetOrderByEmailOptions, throwOnError?:boolean): Promise<IGetOrderResponse> {
		const response: IGetOrderResponse = await this.callCustomEndpoint<IGetOrderResponse>(
			fetchOptions,
			endpointsMap.GET_ORDER
		);

		if (throwOnError && !response.order) {
			throw new Error(response.title || 'Order not found');
		}

		return response;
	}

	/**
	 * Gets an order based on the orderNo and zip code passed
	 * @param {IGetOrderByZipCodeOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetOrderResponse} - Order
	 */
	public async getOrderByZipCode(fetchOptions: IGetOrderByZipCodeOptions, throwOnError?: boolean): Promise<IGetOrderResponse> {
		const response: IGetOrderResponse = await this.callCustomEndpoint<IGetOrderResponse>(
			fetchOptions,
			endpointsMap.GET_ORDER
		);

		if (throwOnError && !response.order) {
			throw new Error('No oder found');
		}

		return response;
	}
}

export default CustomShopperOrders;
